const INDUSTRIES = [
  {
    name: "Cannabis",
    meta: "Revolution Global — #1 Brand 2021 & 2022",
    img: "https://images.unsplash.com/photo-1763256552751-db613582fb2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxzdHJlZXQlMjBhcnQlMjBtdXJhbCUyMGNhbXBhaWdufGVufDB8fHx8MTc3NzAxODMxMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Art & Creative",
    meta: "Muros — 550% Revenue Growth",
    img: "https://images.pexels.com/photos/28674702/pexels-photo-28674702.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Technology / AI",
    meta: "JumpSeat — 100% Client Retention",
    img: "https://images.unsplash.com/photo-1623932078823-c85c584ffc19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxjcmVhdGl2ZSUyMHdvcmtzcGFjZSUyMGFnZW5jeXxlbnwwfHx8fDE3NzcwMTgzMTF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Sports Marketing",
    meta: "NFL · NBA · MLB · NHL · MLS — 155K+ built from 0",
    img: "https://images.unsplash.com/photo-1764439063840-a03b75a477f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHx0ZW5uaXMlMjBjb3VydCUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3NzcwMTgzMjd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Higher Ed & Institutions",
    meta: "Councilor — Century-old brand, modernized",
    img: "https://images.unsplash.com/photo-1719935115623-4857df23f3c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxhcnQlMjBnYWxsZXJ5JTIwZXhoaWJpdGlvbnxlbnwwfHx8fDE3NzcwMTgzMjd8MA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Industries() {
  return (
    <section data-testid="industries-section" className="px-4 md:px-8 lg:px-12 py-20 md:py-28 bg-[#E8E4DB] hard-border-t hard-border-b">
      <div className="mb-10 max-w-6xl">
        <div className="section-label mb-3 text-[#4A4A4A]">§ 03 — Industries</div>
        <h2 className="font-anton uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.92]">
          Fluent across
          <span className="font-cormorant italic text-[#2E4F36] font-semibold"> multiple </span>
          categories.
        </h2>
        <p className="font-work text-lg md:text-xl mt-6 max-w-2xl">
          Cannabis, art &amp; creative, technology, sports, and higher-ed institutions — each
          category has its own audience, its own language, and its own definition of success.
          The strategy changes; the discipline doesn&apos;t.
        </p>
      </div>

      <ul className="hard-border-t">
        {INDUSTRIES.map((ind, i) => (
          <li
            key={ind.name}
            className="industry-row hard-border-b py-6 md:py-8 flex items-baseline justify-between gap-6 cursor-pointer"
            data-testid={`industry-row-${i}`}
          >
            <div className="flex items-baseline gap-4 md:gap-8">
              <span className="font-anton uppercase text-4xl md:text-6xl lg:text-7xl leading-none">
                {ind.name}
              </span>
            </div>
            <div className="hidden md:block font-mono-s text-xs uppercase tracking-[0.2em] text-[#1a1a1a] text-right max-w-sm">
              {ind.meta}
            </div>
            <img src={ind.img} alt="" className="preview-img" loading="lazy" />
          </li>
        ))}
      </ul>
    </section>
  );
}
